// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Nav Tabs Component */
nav-tabs {
  display: block;
}

.nav-tabs-container {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.nav-tabs-btn {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 0.75rem;
  border: none;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all var(--transition-normal);
  background: transparent;
  color: var(--text-muted);
  width: 100%;
  text-align: left;
  font-family: inherit;
}

.nav-tabs-btn:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.dark .nav-tabs-btn:hover {
  background-color: var(--bg-card);
}

.nav-tabs-btn.active {
  background-color: var(--btn-active-bg);
}

.nav-tabs-count {
  margin-left: auto;
  font-size: 0.75rem;
  font-weight: 600;
  opacity: 0.8;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/nav-tabs.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,wCAAwC;EACxC,uBAAuB;EACvB,wBAAwB;EACxB,WAAW;EACX,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd","sourcesContent":["/* Nav Tabs Component */\nnav-tabs {\n  display: block;\n}\n\n.nav-tabs-container {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.nav-tabs-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.5rem 0.75rem;\n  border: none;\n  border-radius: 0.5rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all var(--transition-normal);\n  background: transparent;\n  color: var(--text-muted);\n  width: 100%;\n  text-align: left;\n  font-family: inherit;\n}\n\n.nav-tabs-btn:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.dark .nav-tabs-btn:hover {\n  background-color: var(--bg-card);\n}\n\n.nav-tabs-btn.active {\n  background-color: var(--btn-active-bg);\n}\n\n.nav-tabs-count {\n  margin-left: auto;\n  font-size: 0.75rem;\n  font-weight: 600;\n  opacity: 0.8;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
